import React from "react";
import { INoticeDetails } from "../../../models/interfaces/INotice";



interface IProps {
  NoticeResult: INoticeDetails;
}

const Bloc10: React.FC<IProps> = ({ NoticeResult }) => {
  return (
    <>
      {NoticeResult?.groupeTitres &&
    (NoticeResult?.groupeTitres?.titresContenus?.some(tc => tc?.mentions?.length > 0) ||
     NoticeResult?.groupeTitres?.titresPrincipaux?.some(tp => tp?.mentions?.length > 0)) && (
      <>
          <div className="card" style={{ textAlign: 'left' }}>
              <div className="col-sm-12 card-body pae-card-grey">
                    {NoticeResult?.groupeTitres?.titresContenus?.length > 0 ? (
                      <b className="pae-detail-section-title mb-2">Réunit</b>
                    ) : (
                      <b className="pae-detail-section-title mb-2">Détail des contributions</b>
                    )}
              </div>
              <div className="col-sm-12 card-body">
                {NoticeResult?.groupeTitres?.titresContenus?.length > 0 ? (
                  <>
                    {NoticeResult?.groupeTitres?.titresContenus?.map((itemTitresContenus,indexTitresContenus) => (
                      <React.Fragment key={indexTitresContenus}> 
                        {itemTitresContenus?.titres?.map((itemTitre, indexTitre) => (
                          <div key={indexTitre}>{itemTitre.libelle}</div>
                        ))}
                        {itemTitresContenus?.mentions?.map((itemMention, indexMention) => (
                          <div key={indexMention}>{itemMention}</div>
                        ))}
                      </React.Fragment>
                    ))}
                  </>
                ) : (
                  <>
                    {NoticeResult?.groupeTitres?.titresPrincipaux?.map((itemTitresPrincipaux,indexTitresPrincipaux) => (
                        <React.Fragment key={indexTitresPrincipaux}>
                          {itemTitresPrincipaux?.titres?.map((itemTitre, indexTitre) => (
                            <div key={indexTitre}>{itemTitre.libelle}</div>
                          ))}
                          {itemTitresPrincipaux?.mentions?.map((itemMention, indexMention) => (
                            <div key={indexMention}>{itemMention}</div>
                          ))}
                        </React.Fragment>
                    ))}
                  </>
                )}
              </div>
        </div>   
        <br></br> 
            
          </>
        )}
    </>
  );
};

export default Bloc10;
